import { createStyles } from 'antd-style';

export default createStyles((props: { isDarkMode: boolean }) => {
  const taChevronDarkBackgroundColor = '#32312f';

  return {
    appNameBannerStyle: {
      backgroundColor: props.isDarkMode ? taChevronDarkBackgroundColor : '#fff',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      boxShadow: props.isDarkMode
        ? '-6px 0 5px 0px rgba(0, 0, 0, 0.4)'
        : '-6px 0 5px 0px rgba(100, 100, 100, 0.2)',
      paddingLeft: '15px',
      marginRight: '60px',
      overflowY: 'clip',
      img: {
        width: '45px',
        zIndex: 1
      },
      a: {
        display: 'flex',
        flexDirection: 'column',
        color: 'unset'
      },
      '& .title-container': {
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '11pt',
        zIndex: 1,
        marginRight: 'calc(-.5px * sqrt(2 * pow(64,2)))',
        div: { lineHeight: '20px' },
        'div:last-child': {
          fontSize: '15pt'
        }
      },
      '&:after': {
        position: 'relative',
        right: 'calc(-.5px * sqrt(2 * pow(64,2)))', // using half the hypotenuse
        marginLeft: 'calc(-.5px * sqrt(2 * pow(64,2)))',
        content: "''",
        backgroundColor: props.isDarkMode ? taChevronDarkBackgroundColor : '#fff',
        transform: 'rotate(-45deg)',
        height: '64px',
        width: '64px',
        boxShadow: props.isDarkMode
          ? '1px 6px 0px 0px rgba(0, 0, 0, 0.4)'
          : '1px 6px 0px 0px rgba(100, 100, 100, 0.2)'
      }
    }
  };
});
